export default {
  tips: [
    "حفظ محرمانگی کلید API: کلیدهای API شما به عنوان یک رمز عبور عمل می‌کنند. هرگز آن‌ها را با دیگران به اشتراک نگذارید و از ارسال آن‌ها در ایمیل یا پیام‌های عمومی خودداری کنید.",
    "استفاده از محیط‌های امن: کلیدهای API را فقط در محیط‌های امن و معتبر استفاده کنید. از قرار دادن آن‌ها در کدهای منبع عمومی یا مخازن گیت هاب خودداری کنید.",
    "نظارت بر فعالیت‌ها: به طور منظم فعالیت‌های مرتبط با کلیدهای API خود را بررسی کنید. در صورت مشاهده هرگونه فعالیت مشکوک، بلافاصله کلید خود را غیرفعال کنید.",
    "حفظ امنیت: کلیدهای شما هر ۷ روز منقضی می‌شوند و لازم است کلیدهای جدید دریافت کنید."
  ],
  documentation: "مستندات API",
  footer:
    "این نکات به شما کمک می‌کند تا از امنیت حساب کاربری خود محافظت کنید و از سوءاستفاده‌های احتمالی جلوگیری نمایید."
};
